'use client'

import { useRouter, useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'

import Carousel from './carousel'

import { sliderBackground } from '@/libs/constants/images-library'

const Slider = () => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const [hideSlider, setHideSlider] = useState<boolean>(false)

  useEffect(() => {
    setHideSlider(window.location.hash === '#hide-slider')

    const handleHashChange = () => {
      setHideSlider(window.location.hash === '#hide-slider')
    }

    window.addEventListener('hashchange', handleHashChange)

    return () => {
      window.removeEventListener('hashchange', handleHashChange)
    }
  }, [])

  const handleNavigation = (path: string) => {
    const queryString = searchParams.toString()
    const url = queryString ? `${path}?${queryString}` : path

    window.location.hash = 'hide-slider'
    router.push(url)
  }

  return (
    <div
      style={{
        backgroundImage: `url(${sliderBackground.src})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
      className={`fixed z-50 flex h-full w-full flex-col lg:relative lg:h-screen lg:max-w-md ${
        hideSlider ? 'hidden lg:block' : ''
      }`}
    >
      <Carousel />
      <div className='flex h-24 w-full items-center lg:hidden'>
        <div className='mx-auto flex w-full flex-row justify-between gap-4 px-6 md:w-3/4'>
          <button
            className='w-full rounded-full border border-white py-3 font-medium text-white'
            onClick={() => handleNavigation('/auth/login')}
            type='button'
          >
            Login
          </button>
          <button
            className='w-full rounded-full bg-white py-3 font-medium text-pop-blue-700'
            onClick={() => handleNavigation('/auth/register')}
            type='button'
          >
            Register
          </button>
        </div>
      </div>
    </div>
  )
}

export default Slider
